import { useNavigate } from 'react-router-dom';
import { boolean } from 'yup';
import Geocode from "react-geocode";
import {encryptStorage} from '../CustomStorage';
import { API_ENDPOINTS,APP_CONSTANTS,IOT_NOTIFICATION_EVENTS, ONGOING_VIDEO_CALL_DATA,SOUNDBOX_APP_CONSTANTS } from '../URLConstants';



export function toLowerCase(str){
    if(str!==undefined && str!==null)
return str.toLowerCase();
}





export function Signout(){


}

export function clearLocalDataOfUserLogins(){

  encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
  encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
  encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_IOT_CLIENT_ID);
  encryptStorage.removeItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN);


  // window.location.reload();

}

export function clearLoginSession(){

  encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
  encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
  encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);

}


export function clearLocalDataForSoundBoxLogin(){

  // encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
  // encryptStorage.removeItem(SOUNDBOX_APP_CONSTANTS.L_KEY_OF_COGNITO_TOKEN);

  // window.location.reload();

}

/* eslint-disable */
export function parseJwt (token) {
  if(token!==undefined && token!==null){
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  
    return JSON.parse(jsonPayload);
  }

  return null
  
}

/* eslint-enable */



export function replaceClientId(topic,replaceWith){
  return topic.replace("<client_id>",encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_IOT_CLIENT_ID))
}

export function getRandomColorVariant(){

  const colorVariants = ["primary", "secondary",
  "error", "danger"];

  return colorVariants[Math.floor(Math.random() * colorVariants.length)];
}

export function getNotificationSeverity(eventType){

  if(eventType!==null && eventType!==undefined){
    switch(eventType){
      case IOT_NOTIFICATION_EVENTS.FLAMMABLE_GAS_DETECTED_ALERT: return "High"
      case IOT_NOTIFICATION_EVENTS.DEVICE_PROXIMITY_ALERT: return "Medium"
      case IOT_NOTIFICATION_EVENTS.DEVICE_FALL_ALERT: return "Medium"
      case IOT_NOTIFICATION_EVENTS.DEVICE_SCANNER_DATA: return "Low"
      case IOT_NOTIFICATION_EVENTS.DEVICE_BATTERY_LOW_ALERT: return "Low"
      default: return "Normal"
    }
  }

  return "Normal"
    
}

export function getSensorType(key){

    if(key!==undefined && key!==null){

      switch(key){
        case "AMBIENT_LIGHT": return "Light Sensor";
        case "TEMPERATURE_SUBJECT": return "Body Temp.";
        case "TEMPERATURE_ENVIRONMENT": return "Environment Temp.";
        case "PRESSURE": return "Pressure";
        case "HUMIDITY": return "Humidity";
        case "DEVICE_WORN": return "Device Worn";
        default : return ""
      }
    }

    return ""
}


export function getSensorTypeText(key){

  if(key!==undefined && key!==null){

    switch(key){
      case "AMBIENT_LIGHT": return "Light";
      case "TEMPERATURE_SUBJECT": return "Body Temp.";
      case "TEMPERATURE_ENVIRONMENT": return "Environment Temp.";
      case "PRESSURE": return "Pressure";
      case "HUMIDITY": return "Humidity";
      default : return ""
    }
  }

  return ""
}

export function setOngoingCallData(callId, userData){

  ONGOING_VIDEO_CALL_DATA.id=callId;
  ONGOING_VIDEO_CALL_DATA.userData=userData;
}

export function showFieldValueWithCheck(value){
   return value !==undefined && value!=="" && value !==null ? value :"---"
}

export function showLanguageLabelUsingCode(languageCode){

  if(languageCode===undefined || languageCode===null)
    return ""

    switch (languageCode.toLowerCase()){
      case "en":{
        return "English"
      }
      case "english":{
        return "English"
      }
      case "eng":{
        return "English"
      }
      case "hi":{
        return "Hindi"
      }
      case "hindi":{
        return "Hindi"
      }
      case "bengali":{
        return "Bengali"
      }
      case "tamil":{
        return "Tamil"
      }
      case "telgu":{
        return "Telgu"
      }
      default:{
        return languageCode
      }
    }
}

export function getTransactionAnnouncedOrNot(value) {

  if(value==='' || value===undefined || value===null || value==='NULL' || value==='null')
    return 'NA'

  switch (value.toLowerCase()) {
    case 'completed': {
      return 'YES'
    }
    case 'failed':{
      return 'NO'
    }
    default: {
      return "NO"
    }
  }
}


export function showTextOnUIwithDash(value) {

  if(value==='' || value===undefined || value===null || value==='Null' || value==='null' || value==='Not Available')
    return '---'

    return value
}

  

export function getIdTextWidthDots(idStr){

  // if (idStr === null || idStr === undefined)
  // return ''

  //   return idStr.substring(idStr.length-5,idStr.length)

  if (idStr === null || idStr === undefined || idStr==='' )
  return ''

if (idStr.length > 5) {
  const lastFiveChars = idStr.slice(-5);
  return 'X'.repeat(idStr.length/3) + lastFiveChars;
}

return idStr

}

export function crossMarkString(inputString) {

  if (inputString === null || inputString === undefined)
    return ''

  if (inputString.length > 6) {
    const lastFiveChars = inputString.slice(-6);
    return 'X'.repeat(5) + lastFiveChars;
  }

  return inputString

};

export function crossMarkDeviceIdString(inputString) {

  if (inputString === null || inputString === undefined)
    return ''

  if (inputString.length > 4) {
    const lastFiveChars = inputString.slice(-4);
    return 'X'.repeat(3) + lastFiveChars;
  }

  return inputString

};

export function parseValidationErrorMessage(error){
 
  if (error?.response?.data) {
    const { validationErrors } = error.response.data;
    if (validationErrors) {
      if ("message" in validationErrors) {
        return validationErrors.message;
      } 
       if ("errors" in validationErrors) {
        return validationErrors.errors;
      }
    }
  }
  
  return "Bad Request";
  
    
}
export function capitalizeFirstLetter(str){
  
  if(str!==undefined && str!==null && str!=='')
  return str.charAt(0).toUpperCase() + str.slice(1);

  return str

}

export function getUserAciveInactiveBasedColor(status){

  if(status===null || status===undefined || status==='')
    return "info"

  switch(status.toLowerCase()){
    case "active":{
      return "info"
    }
    case "inactive":{
      return "error"
    }
    default:{
      return "info"
    }
  }
}

export function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string?.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value?.toString(16)}`?.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name?.split(' ')[0][0]}${name?.split(' ')?.[1]?.[0]}`,
  };
}

export function getBgColorUsingUserRole(role){

  switch(role){
    case "admin":return "#0080BF"
    case "maker":return "#55D0FF"
    case "checker":return "#CCF9FF"
    default: return "info"
  }

}

export function getTextColorUsingUserRole(role){

  switch(role){
    case "checker":return "#000000"
    default: return "#FFF"
  }

}

export function getBatteryPerceByVBAT(VBAT){
  if(VBAT!==null && VBAT!==undefined && VBAT!==''){
    const voltage=Math.min(4.15,Math.max(VBAT,3.4))
    return parseInt(((voltage-3.4) *100)/ (4.15-3.4),10)
  }
  return '---'
 
}
